"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearGroceryListMutationOptions = exports.clearGroceryListMutation = void 0;
const client_1 = require("@apollo/client");
const groceryItems_1 = require("../queries/groceryItems");
exports.clearGroceryListMutation = client_1.gql `
  mutation ClearGroceryList {
    clearGroceryList {
      ok
    }
  }
`;
exports.clearGroceryListMutationOptions = () => ({
    update: store => {
        store.writeQuery({
            query: groceryItems_1.groceryItemsQuery,
            data: {
                __typename: "Query",
                groceryItems: {
                    __typename: "GroceryItemsResponse",
                    items: [],
                    recipes: [],
                },
            },
        });
    },
});
//# sourceMappingURL=ClearGroceryList.js.map